import { render, staticRenderFns } from "./d-user-link-popup.vue?vue&type=template&id=5aaaf073&scoped=true&"
import script from "./d-user-link-popup.vue?vue&type=script&lang=js&"
export * from "./d-user-link-popup.vue?vue&type=script&lang=js&"
import style0 from "./d-user-link-popup.vue?vue&type=style&index=0&id=5aaaf073&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aaaf073",
  null
  
)

export default component.exports